import React from 'react';

// Styles - Main SCSS entry point
import './styles/main.scss';
import 'react-date-range/dist/styles.css';
import 'react-date-range/dist/theme/default.css';
import "react-datepicker/dist/react-datepicker.css";

// Router
import {
    BrowserRouter as Router,
    Route, Switch, Redirect
} from "react-router-dom";

// Context
import { UserProvider } from "./userContext";

// Components
import Error from "./Layout/Error";

// Views
import Login from './Views/Login';
import Dashboard from "./Views/Dashboard";
import ResetPassword from "./Views/ResetPassword";
import SetNewPassword from "./Views/SetNewPassword";
import Creation from "./Views/Creation";

// Routes
import LoginRoute from "./Routes/LoginRoute";

const baseURL = document.getElementsByTagName('base')[0]?.getAttribute('href') || '/';

function App() {
    return (
        <UserProvider>
            <Router forceRefresh={false} basename={baseURL}>
                <div className="App">
                    <Switch>
                        <Route path="/login" exact component={Login} />
                        <Route path="/reset" exact component={ResetPassword} />
                        <Route path="/creation/:token" exact component={Creation} />
                        <Route path="/resetPassword/:token" exact component={SetNewPassword} />
                        <LoginRoute path="/" exact component={Dashboard} />
                        <LoginRoute path="/404" component={Error} />
                        <Redirect from="*" to="/404" />
                    </Switch>
                </div>
            </Router>
        </UserProvider>
    );
}

export default App;
